import { useState } from "react";
import AllBidsResponseModel from "./AllBidsResponseModel";
import DomainsInputModel from "./DomainsInputModel";
import SelectPriorityModel from "./SelectPriorityModel";

type BackorderProps = {
    openBackorder: boolean;
    maxPossibleOrders: number;
    setOpenBackorder: React.Dispatch<React.SetStateAction<boolean>>;
    setReloadData: React.Dispatch<React.SetStateAction<number>>;
};

export type Order = {
    domainName: string;
    priority: number;
};

export type OrderResponse = {
    domain: string;
    success: boolean;
    reason: string;
};

export default function BackorderModel(props: BackorderProps) {
    const {
        openBackorder,
        maxPossibleOrders,
        setOpenBackorder,
        setReloadData,
    } = props;

    const [isPriorityOpen, setIsPriorityOpen] = useState<boolean>(false);
    const [isResponseOpen, setIsResponseOpen] = useState<boolean>(false);

    const [orderDomains, setOrderDomains] = useState<Order[]>([]);
    const [orderResponse, setOrderResponse] = useState<OrderResponse[]>([]);

    if (isPriorityOpen) {
        return (
            <SelectPriorityModel
                isOpen={isPriorityOpen}
                domains={orderDomains}
                setIsOpen={setIsPriorityOpen}
                setIsResponseOpen={setIsResponseOpen}
                setOrderResponse={setOrderResponse}
            />
        );
    }

    if (isResponseOpen) {
        return (
            <AllBidsResponseModel
                isOpen={isResponseOpen}
                orderResponse={orderResponse}
                setIsOpen={setIsResponseOpen}
                setReloadData={setReloadData}
            />
        );
    }

    return (
        <DomainsInputModel
            open={openBackorder}
            availBidsCount={maxPossibleOrders}
            setOpen={setOpenBackorder}
            setDomains={setOrderDomains}
            setIsPriorityOpen={setIsPriorityOpen}
        />
    );
}
